function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 12V52H49C49 29.9086 31.0914 12 9 12Z",
  fill: "url(#paint0_linear_feat3)"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 48.5,
  cy: 14.5,
  r: 14.5,
  fill: "url(#paint1_linear_feat3)"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_feat3",
  x1: 29,
  y1: 52,
  x2: 29,
  y2: 12,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#99FFC3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FCFF9E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_feat3",
  x1: 37.3229,
  y1: 14.4988,
  x2: 63,
  y2: 14.4988,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#8CF2A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#4DF177"
})));

var SvgFeature3 = function SvgFeature3(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 52,
    viewBox: "0 0 99 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFeature3, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/feature-3.12882005.svg";
export { ForwardRef as ReactComponent };